<div class="page-container">
    <div class="page-content">
        <map-dataset-config
            [groups]="groups"
            #datasetConfig [form]="createOverlayForm"
            [datasetStylingOptions]="datasetStylingOptions"
            [isCreate]="true" [dataset]="dataset"></map-dataset-config>
    </div>
</div>
